<template>
  <div
    v-bind:class="{ active: ConfigStore.config.outputTab }"
    class="modal"
    id="output-modal"
    role="dialog"
    aria-modal="true"
    aria-labelledby="output-modal-title"
  >
    <a
      v-on:click="close"
      class="modal-overlay"
      role="region"
      aria-label="Close dialog"
    />
    <div class="modal-container">
      <div class="modal-header">
        <a
          v-on:click="close"
          class="btn btn-clear float-right"
          role="button"
          aria-label="Close dialog"
        />
        <div class="modal-title h5">
          <span id="output-modal-title">MATPOWER Output</span>
          <HelpButton :section="section" kind="small" />
        </div>
      </div>
      <div class="modal-body pt-0">
        <ul class="tab tab-block my-0" role="tablist">
          <li
            v-if="pfOutput"
            v-bind:class="{ active: tab === 'pf' }"
            class="tab-item"
            role="tab"
            aria-labelledby="pf-output-tab-label"
            aria-controls="pf-output-tab"
            :aria-selected="(tab === 'pf').toString()"
          >
            <a id="pf-output-tab-label" v-on:click="tab = 'pf'">Power Flow</a>
          </li>
          <li
            v-if="opfOutput"
            v-bind:class="{ active: tab === 'opf' }"
            class="tab-item"
            role="tab"
            aria-labelledby="opf-output-tab-label"
            aria-controls="opf-output-tab"
            :aria-selected="(tab === 'opf').toString()"
          >
            <a id="opf-output-tab-label" v-on:click="tab = 'opf'">OPF</a>
          </li>
          <li
            v-if="ioOutput"
            v-bind:class="{ active: tab === 'io' }"
            class="tab-item"
            role="tab"
            aria-labelledby="io-output-tab-label"
            aria-controls="io-output-tab"
            :aria-selected="(tab === 'io').toString()"
          >
            <a id="io-output-tab-label" v-on:click="tab = 'io'">I/O</a>
          </li>
        </ul>
        <pre
          v-if="tab === 'pf'"
          id="pf-output-tab"
          class="content code mt-0"
          data-lang="MATPOWER"
          role="tabpanel"
        ><code>{{ pfOutput }}</code></pre>
        <pre
          v-if="tab === 'opf'"
          if="opf-output-tab"
          class="content code mt-0"
          data-lang="MATPOWER"
          role="tabpanel"
        ><code>{{ opfOutput }}</code></pre>
        <pre
          v-if="tab === 'io'"
          id="io-output-tab"
          class="content code mt-0"
          data-lang="MATPOWER"
          role="tabpanel"
        ><code>{{ ioOutput }}</code></pre>
      </div>
    </div>
  </div>
</template>

<script>
import ConfigStore from "../stores/ConfigStore";
import IOStore from "../stores/IOStore";
import PFStore from "../stores/PFStore";
import OPFStore from "../stores/OPFStore";

import HelpButton from "../components/HelpButton";

export default {
  name: "OutputModal",
  components: { HelpButton },
  data() {
    return { ConfigStore: ConfigStore.data };
  },
  computed: {
    tab: {
      get() {
        return ConfigStore.data.config.outputTab;
      },
      set(tab) {
        ConfigStore.data.config.outputTab = tab;
      }
    },
    section() {
      return this.tab === "pf" ? "runpf" : "runopf";
    },
    ioOutput() {
      let output = IOStore.data.output;
      return output.startsWith("\n") ? output.slice(1) : output;
    },
    pfOutput() {
      let output = PFStore.data.output;
      return output.startsWith("\n") ? output.slice(1) : output;
    },
    opfOutput() {
      let output = OPFStore.data.output;
      return output.startsWith("\n") ? output.slice(1) : output;
    }
  },
  methods: {
    close() {
      ConfigStore.data.config.outputTab = "";
    }
  }
};
</script>
